import React from 'react';
import useDashboardApexChart from '../../hook/useDashboardApexChart';

const UsersGraph = ({ graphData }) => {

    const { createChartSix } = useDashboardApexChart();

    const {
        totalTamilUsers = 0,
        totalEnglishUsers = 0,
        trendTamilUsers = [],
        trendEnglishUsers = [],
        xAxisLabels = []
    } = graphData || {};

    return (
        <div className="col-xxl-12">
            <div className="card radius-8 border-0 p-20">
                <div className="row gy-4">

                    {/* STAT CARDS */}
                    <div className="col-xxl-3 d-flex flex-column">

                        <div className="card p-3 radius-8 shadow-none bg-gradient-dark-start-1 mb-12 flex-fill">
                            <div className="card-body p-0">
                                <div className="d-flex align-items-center gap-2 mb-12">
                                    <span className="mb-0 w-48-px h-48-px bg-base text-primary text-2xl d-flex justify-content-center align-items-center rounded-circle h6">
                                        <i className="ri-user-3-fill"></i>
                                    </span>
                                    <span className="fw-medium text-secondary-light text-lg">
                                        Tamil Users
                                    </span>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                    <h5 className="fw-semibold mb-0">{totalTamilUsers}</h5>
                                </div>
                            </div>
                        </div>

                        <div className="card p-3 radius-8 shadow-none bg-gradient-dark-start-2 mb-12 flex-fill">
                            <div className="card-body p-0">
                                <div className="d-flex align-items-center gap-2 mb-12">
                                    <span className="mb-0 w-48-px h-48-px bg-base text-purple text-2xl d-flex justify-content-center align-items-center rounded-circle h6">
                                        <i className="ri-user-3-fill"></i>
                                    </span>
                                    <span className="fw-medium text-secondary-light text-lg">
                                        English Users
                                    </span>
                                </div>
                                <div className="d-flex align-items-center justify-content-between">
                                    <h5 className="fw-semibold mb-0">{totalEnglishUsers}</h5>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* CHART */}
                    <div className="col-xxl-9">
                        <div className="card-body p-0">
                            <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                                <h6 className="mb-2 mt-1 fw-bold text-lg">Users Trend</h6>
                            </div>

                            <ul className="d-flex justify-content-center mt-3 gap-3 stats-legend">
                                <li className="d-flex align-items-center gap-2">
                                    <span className="w-12-px h-12-px rounded-circle bg-primary-600" />
                                    Tamil Users<span className="legend-value">: <b>{totalTamilUsers}</b></span>
                                </li>
                                <li className="d-flex align-items-center gap-2">
                                    <span className="w-12-px h-12-px rounded-circle bg-purple" />
                                    English Users<span className="legend-value">: <b>{totalEnglishUsers}</b></span>
                                </li>
                            </ul>

                            <div className="mt-40">
                                <div id="usersChart" className="apexcharts-tooltip-style-1">
                                    {createChartSix('#487fff', '#9b59b6', trendTamilUsers, trendEnglishUsers, xAxisLabels, 'Tamil Users', 'English Users')}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default UsersGraph;
